<fieldset ngModelGroup="region-generalites">
    <mat-card>
        <mat-card-title>
            <span [translate]="'admin.bibliotheque.geographie.region.title'" [translateParams]="{libelle: ''}"></span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="libelle"
                                  name="libelle"
                                  [(ngModel)]="region.libelle"
                                  customType="input"
                                  libelle="admin.bibliotheque.geographie.territoire.libelle"
                                  [required]="true">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="pays"
                                  name="pays"
                                  [idName]="'libelle'"
                                  optionValue="libelle"
                                  (onChange)="onPaysChange();"
                                  [(ngModel)]="selectedPays"
                                  customType="autocomplete"
                                  autocompleteType="geographie"
                                  optionDisplay="libelle"
                                  [autocompleteFilter]="{listeTypes: ['PAYS']}"
                                  libelle="admin.bibliotheque.geographie.region.pays"
                                  [required]="true">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="code"
                                  name="code"
                                  [(ngModel)]="region.code"
                                  customType="input"
                                  libelle="admin.bibliotheque.geographie.territoire.code"
                                  [required]="true">
                    </custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
</fieldset>
